import React, { useState, useRef } from 'react'
import { NavLink, useMatch } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import RoundedIcon from '~components/ui/RoundedIcon'
import { isScreenSize } from '~helpers/mediaQuery'

const MenuItem = ({ link, title, icon = 'dashboard', basket, exact, items, toggleNav }) => {
  const [open, setOpen] = useState(false)
  const subNavRef = useRef(null)
  const match = useMatch(`${link}/*`)
  const isActive = !!match

  const toggleDropdown = () => {
    setOpen(!open)
  }

  const handleNavDropdown = (e) => {
    if (items) {
      toggleDropdown()

      if (!isScreenSize('lg')) {
        e.preventDefault()
      }
    } else {
      toggleNav()
    }
  }

  return (
    <>
      <NavLink
        to={link}
        exact={exact.toString()}
        className="relative flex items-center group lg:h-full lg:px-6 xl:px-10 lg:-ml-6 xl:-ml-10"
        onClick={handleNavDropdown}
      >
        <span className="relative block mr-2">
          <RoundedIcon
            name={icon}
            className="block w-7 h-7"
            active={isActive}
          />

          {basket && (
            <span className="absolute top-0 right-0 block w-2 h-2 rounded-1/2 bg-charcoal" aria-hidden="true">
              <span className="absolute top-0 bottom-0 left-0 right-0 inline-flex w-full h-full m-auto rounded-full opacity-75 animate-limited-ping bg-charcoal"></span>
            </span>
          )}
        </span>

        {title}

        {items && (
          <span
            aria-hidden="true" className={classNames(
              'hidden lg:absolute lg:bottom-0 h-0 w-0 absolute border-r-10 border-l-10 border-b-10 border-triangle',
              { 'lg:block': isActive && items }
            )}
          >
          </span>
        )}
      </NavLink>

      <div
        ref={subNavRef}
        className={classNames(
          'bg-pink py-10 relative mt-6 extend-bg-left extend-bg-right max-height-0 lg:p-0 lg:absolute lg:w-full lg:left-0 lg:right-0 lg:mt-0 lg:top-full lg:py-1 lg:transition-all lg:duration-200 lg:ease-in-out',
          { block: open },
          { hidden: !open },
          { 'lg:flex': isActive && items },
          { 'lg:hidden': !isActive }
        )}
      >
        <ul className="xxl:container lg:w-full lg:mx-auto lg:px-8 lg:flex xxl:px-0">
          <span
            aria-hidden="true"
            className="absolute left-0 block w-0 h-0 -top-3 border-r-10 border-l-10 border-b-10 border-triangle lg:hidden"
          />

          {items && items.map((child, index) => (
            <li
              className={classNames('lg:mt-0 lg:mr-6', { 'mt-10': index > 0 })}
              key={index}
            >
              <NavLink
                to={child.link}
                className="focus:underline hover:underline"
                onClick={toggleNav}
              >
                {child.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

MenuItem.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  basket: PropTypes.bool,
  exact: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  })),
  toggleNav: PropTypes.func
}

export default MenuItem
